import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../../common/action-namespace';

const withNameSpace = withGenesysCloudStoreNameSpace('Conversations');

export const openConversationWorkItem = createAction(
  withNameSpace('Open conversation workItem'),
  props<{ conversationId: string, focus: boolean }>()
);

export const closeConversationWorkItem = createAction(
  withNameSpace('Close conversation workItem'),
  props<{ conversationId: string }>()
);

export const removeWorkItemNotification = createAction(
  withNameSpace('Remove workItem notification'),
  props<{ conversationId: string }>()
);
